export const LOCALIZATION_KEYS: ILocalization = Object.freeze({
  COUNTRY: 'country',
  LANGUAGE: 'language',
  LOCALE: '2goLang',
});

interface ILocalization {
  COUNTRY: string;
  LANGUAGE: string;
  LOCALE: string;
}
